var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUploadBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#092E5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 10.668C20.1408 10.668 20.2812 10.6957 20.4121 10.75C20.5106 10.7909 20.6026 10.8465 20.6846 10.9141L20.7627 10.9854L27.5127 17.7354C27.6131 17.8354 27.6927 17.9541 27.7471 18.085C27.8015 18.216 27.8301 18.3571 27.8301 18.499C27.8301 18.6409 27.8015 18.7811 27.7471 18.9121C27.7063 19.0104 27.6513 19.1017 27.584 19.1836L27.5127 19.2627C27.4125 19.3632 27.2931 19.4427 27.1621 19.4971C27.0311 19.5514 26.8908 19.5801 26.749 19.5801C26.6072 19.5801 26.4669 19.5514 26.3359 19.4971C26.2049 19.4427 26.0855 19.3632 25.9854 19.2627L21.0781 14.3555V28.25C21.0781 28.5357 20.9646 28.8096 20.7627 29.0117C20.5605 29.2139 20.2859 29.3281 20 29.3281C19.7141 29.3281 19.4395 29.2139 19.2373 29.0117C19.0354 28.8096 18.9219 28.5357 18.9219 28.25V14.3555L18.8418 14.4355L14.0127 19.2627C13.8102 19.4652 13.5354 19.5791 13.249 19.5791C12.9626 19.5791 12.6879 19.4652 12.4854 19.2627C12.2828 19.0602 12.169 18.7854 12.1689 18.499C12.1689 18.2126 12.2828 17.9379 12.4854 17.7354L19.2354 10.9854C19.3355 10.8848 19.4549 10.8044 19.5859 10.75C19.7169 10.6957 19.8573 10.668 19.999 10.668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.09375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadBtn);
export default __webpack_public_path__ + "static/media/ic_upload_btn.bf75801655ba478293f95619cd736f96.svg";
export { ForwardRef as ReactComponent };